import React from "react";

const LetsWorkTogether = () => {
  return (
    <section className="lead">
      <div className="container text-center">
        <div className="row align-items-center">
          <div className="col-12">
            <div className="lead-title text-white mb-5 mt-4">
              <h2 className="lead-title">Let's Build Together</h2>
              <p className="mt-4 mb-4 title-font-2">
                Scaling-up your business is our mission!
              </p>

              <a href="mailto:letsbuild@famoron.co">
                <button className="leadbutton btn text-white">
                  Let's do this
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LetsWorkTogether;
